import { SubscriptionLandingInfo } from "../../types/Paywall";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

export const updatePaywall = async (
  paywall: SubscriptionLandingInfo & { id?: string }
): Promise<void> => {
  if (!paywall.id) {
    throw new Error("Community ID is required to update paywall");
  }

  const paywallRef = firestore
    .collection(DB_PATH.COMMUNITY)
    .doc(paywall.id)
    .collection("landingPage")
    .doc("info");

  // Remove the id from the payload since we're storing it at the document level
  const { id, ...data } = paywall;

  // Remove undefined fields (Firestore doesn't accept undefined values)
  const payload = Object.entries(data).reduce((acc, [key, value]) => {
    if (value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {} as any);

  try {
    await paywallRef.set(payload, { merge: true });
  } catch (error) {
    console.error("Error updating paywall", error);
  }
};
